import { useState, useEffect, useCallback } from "react";

let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState(false);
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userId, setUserId] = useState(false);
  const [username, setUsername] = useState(false);
  const [image, setImage] = useState(false);

  const login = useCallback(
    (uid, token, username, image, expirationDate) => {
      setToken(token);
      setUserId(uid);
      setUsername(username);
      setImage(image);
      const tokenExpiration =
        expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60);
      setTokenExpirationDate(tokenExpiration);

      localStorage.setItem(
        "userData",
        JSON.stringify({
          userId: uid,
          token: token,
          username: username,
          image: image,
          expirationDate: tokenExpiration.toISOString(),
        })
      );
    },
    [setTokenExpirationDate]
  );

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);
    setImage(null);
    localStorage.removeItem("userData");
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime =
        tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storeData = JSON.parse(localStorage.getItem("userData"));
    if (storeData && storeData.token && new Date(storeData.expirationDate)) {
      login(
        storeData.userId,
        storeData.token,
        storeData.username,
        storeData.image,
        new Date(storeData.expirationDate)
      );
    }
  }, [login]);

  return { token, login, logout, userId, username, image };
};
